import {headers, urlbase} from "../constants/Constants";
import axios from "axios";

export async function getUserData(token: string, student_id: string) {
    try {
        const url = urlbase().concat('leaderboard?token='.concat(token));

        const userDataResponse = await axios.get(url, {params: {student_id}});

        return {code: 200, message: userDataResponse.statusText, data: userDataResponse.data};
    } catch(e) {
        return {code: e.code, message: e.response, data: e.response};
    }
}

export async function getMoreLeaderboards(token: string, skip: number, take: number) {
    try {
        const url = urlbase().concat('leaderboardv2?token=').concat(token);

        const getMoreLeadersResponse = await axios.get(url, {params: {skip, take}});

        return {code: getMoreLeadersResponse.status, message: getMoreLeadersResponse.statusText, data: getMoreLeadersResponse.data};

    } catch (e) {
        return {code: e.status, message: e.response, data: e.response};
    }
}

export async function getTestHistory(token: string) {
    try {
      const url = urlbase().concat('student/history?token=').concat(token);

      const testHistoryResponse = await axios.get(url, {headers: headers()});

      return {code: 200, message: testHistoryResponse.statusText, data: testHistoryResponse.data};
    } catch (e) {
        return {code: e.code, message: e.response, data: e.response};
    }
}
